/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VPCSchema
 */
export interface VPCSchema {
    /**
     * 
     * @type {string}
     * @memberof VPCSchema
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VPCSchema
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VPCSchema
     */
    cidr: string;
}

/**
 * Check if a given object implements the VPCSchema interface.
 */
export function instanceOfVPCSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "cidr" in value;

    return isInstance;
}

export function VPCSchemaFromJSON(json: any): VPCSchema {
    return VPCSchemaFromJSONTyped(json, false);
}

export function VPCSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): VPCSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': json['id'],
        'cidr': json['cidr'],
    };
}

export function VPCSchemaToJSON(value?: VPCSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'cidr': value.cidr,
    };
}

